export const number = {
  modal: {
    remove: {
      content: `Anda yakin ingin menghapus nomer <b>{number}<b>?`,
      disabled: 'Tidak dapat menghapus nomor pada entry point atau SIP akun'
    },

    create_internal: {
      input: {
        number: {
          title: 'Nomor Telepon'
        }
      }
    }
  },

  list: {
    button: {
      create_internal: 'Tambah nomor ekstensi'
    }
  },

  field: {
    number: 'Nomor',
    type: 'Jenis Nomor',
    type_use: 'Jenis pengguna',
    login: 'Login'
  },

  type: {
    internal: 'Internal | Internal',
    external: 'External | External'
  },

  type_use: {
    use: 'Digunakan',
    not_use: 'Tidak digunakan'
  }
};
